import React,{useEffect,useLayoutEffect,useRef,useState} from 'react';
import {useAuth} from '../../contexts/AuthContext';
import {errorMessage} from '../api';
import {bandFrist,bandKonto,bandTitel,restText,RUECKWEG_TEXT} from '../../config/ebenen';
import {sichtBeenden} from '../../components/SichtSchalter';
import './operator.css';

// Das Band einer laufenden Sicht über jeder Seite (SPEC VE-28, VE-30). Einzige Quelle ist das Profilfeld
// sicht.aktiv (VE-29). Vorschau neutral-blau, Vertretung rot; fünf Minuten vor Ablauf eine Ankündigung.
export default function OperatorViewBanner(){
 const {user,checkAuth}=useAuth();
 const aktiv=user?.sicht?.aktiv??null;
 const [jetzt,setJetzt]=useState(()=>new Date()),[fehler,setFehler]=useState(''),[busy,setBusy]=useState(false);
 useEffect(()=>{
  if(!aktiv)return;
  const bis=new Date(aktiv.bis).getTime();
  const takt=setInterval(()=>setJetzt(new Date()),15000);
  // Bei Ablauf fragt das Band den Server; läuft keine Sicht mehr, geht es zurück zur Startebene.
  const ablauf=setTimeout(()=>{void checkAuth();},Math.max(1000,bis-Date.now()+1000));
  return()=>{clearInterval(takt);clearTimeout(ablauf);};
 },[aktiv?.bis,checkAuth]); // eslint-disable-line react-hooks/exhaustive-deps
 const [rueckweg,setRueckweg]=useState<string|null>(null);
 // DR-13 UI-Runde 2c: zurück zur Startebene nur, solange jemand angemeldet ist; wer während einer Sicht abmeldet, bleibt auf
 // der Anmeldeseite, statt dass ein Neuladen von /verwaltung die Navigation dorthin abbricht.
 useEffect(()=>{if(aktiv)setRueckweg(aktiv.rueckweg);else if(rueckweg&&user)window.location.replace(rueckweg);},[aktiv]); // eslint-disable-line react-hooks/exhaustive-deps
 // DR-13 R-02: die Höhe des Bands als --sicht-band-hoehe; ab 721 px füllen Band und Recherchehülle zusammen das Fenster
 // (operator.css), sonst lag der untere Rand der Hülle mit der Eingabe um die Bandhöhe unter dem Fenster.
 const band=useRef<HTMLElement>(null),sichtbar=!!aktiv&&!!user;
 useLayoutEffect(()=>{const element=band.current;if(!element)return;const stil=document.documentElement.style;const messen=()=>stil.setProperty('--sicht-band-hoehe',element.getBoundingClientRect().height+'px');messen();const beobachter=new ResizeObserver(messen);beobachter.observe(element);return()=>{beobachter.disconnect();stil.removeProperty('--sicht-band-hoehe');};},[sichtbar]);
 if(!aktiv||!user)return null;
 const bis=new Date(aktiv.bis),name=`${user.firstName||''} ${user.lastName||''}`.trim()||user.email,rest=restText(bis,jetzt);
 return <section ref={band} role="region" aria-label="Laufende Sicht" className={`sicht-band sicht-band--${aktiv.art==='PREVIEW'?'vorschau':'vertretung'}`}>
  <div><strong>{bandTitel(aktiv)}</strong><span>{bandKonto(name)}</span><span>{bandFrist(bis,jetzt)}</span>
   <span role="status">{rest??''}</span>{fehler&&<span role="alert">{fehler}</span>}</div>
  <button type="button" disabled={busy} onClick={async()=>{setBusy(true);setFehler('');try{await sichtBeenden();}catch(e){setFehler(errorMessage(e));setBusy(false);}}}>{RUECKWEG_TEXT}</button>
 </section>;
}
